import { useMutation } from "react-query";
import { upsertDrugCriminalHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertDrugCriminalHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      upsertDrugCriminalHistory(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while saving the drug & criminal history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    upsertDrugCriminalHistoryMutation: mutate,
    isUpsertDrugCriminalHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpsertDrugCriminalHistory;
